module.exports = "img/flags/TH.7d11409.png";